
<div style="display: flex; flex-direction: row; flex-wrap: wrap;">
    <div id="chart_div" style="height: 200px; width: 550px;"></div>
    <div id="chart_div_wellness" style="height: 200px; width: 550px"></div>
</div>